// @ts-nocheck
import React from 'react';

interface AdminSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const AdminSearchBar: React.FC<AdminSearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Search...',
  className = '',
}) => {
  return (
    <div className={`relative ${className}`}>
      <span className="material-symbols-outlined absolute left-3 top-1/2 transform -translate-y-1/2 text-luna-text-light/50 dark:text-luna-text-dark/50">
        search
      </span>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-10 pr-4 py-2 rounded-lg border border-luna-secondary/30 bg-white dark:bg-luna-primary text-luna-text-light dark:text-luna-text-dark focus:outline-none focus:ring-2 focus:ring-luna-secondary/50"
      />
      {value && (
        <button
          onClick={() => onChange('')}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-luna-text-light/50 dark:text-luna-text-dark/50 hover:text-luna-text-light dark:hover:text-luna-text-dark"
        >
          <span className="material-symbols-outlined text-lg">close</span>
        </button>
      )}
    </div>
  );
};

